export default "__VITE_ASSET__B68jKn9n__"